import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface DocumentsParticipantsAuthsKeyResponse {
  result: {
    authKey: string;
  };
}

interface NewDocumentsParticipantsAuthsKeyResponse {
  verificationKey: string;
  createdAt: string;
}

const convertToDeprecatedResponse = (
  response: NewDocumentsParticipantsAuthsKeyResponse
): DocumentsParticipantsAuthsKeyResponse => {
  return {
    result: {
      authKey: response.verificationKey,
    },
  };
};

/**
 * GET 인증 키 발급
 * @deprecated Endpoint path and response are modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#d1136109e5d64cccba275648f906c517
 */
export function getDocumentsParticipantsAuthsKey({
  documentId,
  participantId,
  workspaceId,
}: {
  documentId: string;
  participantId: string;
  workspaceId: string;
}): Promise<string> {
  return requestApi<NewDocumentsParticipantsAuthsKeyResponse>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/verification/key`
    ),
    method: 'POST',
    credentials: true,
  }).then((response) => convertToDeprecatedResponse(response.data).result.authKey);
}
